import React, { Component } from 'react'
import LoadingOverlay from '../../components/loading/loading';
import { toast } from "react-toastify";
import service from '../../services/service';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class InformationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            about: "",
            rules: "",
            contactNumber: "",
            whatsappNumber: "",
            telegram: "",
            facebook: "",
            instagram: "",
            twitter: "",
            email: "",
            address: "",

            slider1Title: "",
            slider2Title: "",
            slider3Title: "",
            slider1SubTitle: "",
            slider2SubTitle: "",
            slider3SubTitle: "",

            loading: false,
            updateFields: {},
        };
    }

    componentDidMount() {
        this.getInformation();
    }

    changeHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.setState((prevState) => ({
            updateFields: {
                ...prevState.updateFields,
                [name]: value,
            },
        }));
    }

    getInformation = async () => {
        try {
            this.setState({ loading: true });
            const response = await service.view("information");
            if (response && !response.success) {
                toast.error(response.message);
                return;
            }

            this.setState({
                about: response.information.about || "",
                rules: response.information.rules || "",
                contactNumber: response.information.contactNumber || "",
                whatsappNumber: response.information.whatsappNumber || "",
                telegram: response.information.telegram || "",
                facebook: response.information.facebook || "",
                instagram: response.information.instagram || "",
                twitter: response.information.twitter || "",
                email: response.information.email || "",
                address: response.information.address || "",

                slider1Title: response.information.slider1Title || "",
                slider2Title: response.information.slider2Title || "",
                slider3Title: response.information.slider3Title || "",
                slider1SubTitle: response.information.slider1SubTitle || "",
                slider2SubTitle: response.information.slider2SubTitle || "",
                slider3SubTitle: response.information.slider3SubTitle || "",
            });

        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    }

    submitHandler = async (e) => {
        e.preventDefault();
        try {
            this.setState({ loading: true });

            // Prepare the data to send in the PUT request
            const information = {
                about: this.state.about,
                rules: this.state.rules,
                contactNumber: this.state.contactNumber,
                whatsappNumber: this.state.whatsappNumber,
                telegram: this.state.telegram,
                facebook: this.state.facebook,
                instagram: this.state.instagram,
                twitter: this.state.twitter,
                email: this.state.email,
                address: this.state.address,

                slider1Title: this.state.slider1Title,
                slider2Title: this.state.slider2Title,
                slider3Title: this.state.slider3Title,
                slider1SubTitle: this.state.slider1SubTitle,
                slider2SubTitle: this.state.slider2SubTitle,
                slider3SubTitle: this.state.slider3SubTitle,
            };

            const response = await service.save(information, `information/update`, "POST");

            if (response && !response.success) {
                toast.error(response.message + ": " + response.displayMessage);
                return;
            }
            toast.success(response.message + ": " + response.displayMessage);
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    }

    rulesChangeHandler = (value) => {
        this.setState({ rules: value });
        this.setState((prevState) => ({
            updateFields: {
                ...prevState.updateFields,
                rules: value,
            },
        }));
    };

    render() {
        const { about, rules, contactNumber, whatsappNumber, telegram, facebook, instagram, twitter, email, address,
            slider1Title, slider2Title, slider3Title, slider1SubTitle, slider2SubTitle, slider3SubTitle, loading } = this.state;
        return (
            <>
                {loading && <LoadingOverlay />}
                <form
                    onSubmit={this.submitHandler}
                    className="contact-form"
                    style={{
                        padding: "20px",
                        border: "1px solid #ddd",
                        borderRadius: "10px",
                        background: "#fff",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <h3
                        style={{
                            textAlign: "center",
                            marginBottom: "20px",
                            color: "#333",
                            fontSize: "24px",
                            fontWeight: "bold",
                        }}
                    >
                        <i className="fa fa-info-circle" style={{ color: "#007bff" }}></i> Update Website Information
                    </h3>
                    <div className="row">
                        {/* About Section */}
                        <div className="col-lg-12 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-file-alt" style={{ color: "#007bff" }}></i> About
                                </label>
                                <textarea
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={about}
                                    onChange={this.changeHandler}
                                    name="about"
                                    placeholder="Write a brief description about the website..."
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>

                        {/* Rules Section */}
                        <div className="col-lg-12 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-file-alt" style={{ color: "#007bff" }}></i> Update Rules
                                </label>
                                <ReactQuill
                                    theme="snow"
                                    value={rules}
                                    name="rules"
                                    onChange={this.rulesChangeHandler}
                                    placeholder="Write description about the rules..."
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        borderRadius: "8px",
                                        backgroundColor: "white",
                                    }}
                                />
                            </div>
                        </div>

                        {/* Contact Numbers */}
                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-phone" style={{ color: "#34b7f1" }}></i> Contact Number
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={contactNumber}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="contactNumber"
                                    placeholder="Enter contact number (e.g., +1234567890)"
                                />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-envelope" style={{ color: "#3498db" }}></i> Email
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={email}
                                    onChange={this.changeHandler}
                                    type="email"
                                    name="email"
                                    placeholder="Enter email (e.g., johndoe@example.com)"
                                />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-map-marker-alt" style={{ color: "#f39c12" }}></i> Location / Address
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={address}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="address"
                                    placeholder="Enter address (e.g., 123 Main St, City)"
                                />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-whatsapp" style={{ color: "#25d366" }}></i> WhatsApp Number
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={whatsappNumber}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="whatsappNumber"
                                    placeholder="Enter WhatsApp number (e.g., +1234567890)"
                                />
                            </div>
                        </div>

                        {/* Social Media */}
                        <div className="col-lg-4 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-paper-plane" style={{ color: "#0088cc" }}></i> Telegram
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={telegram}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="telegram"
                                    placeholder="Enter Telegram handle (e.g., @YourHandle)"
                                />
                            </div>
                        </div>

                        <div className="col-lg-4 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-facebook" style={{ color: "#1877f2" }}></i> Facebook
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={facebook}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="facebook"
                                    placeholder="Enter Facebook page URL"
                                />
                            </div>
                        </div>

                        <div className="col-lg-4 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-instagram" style={{ color: "#e1306c" }}></i> Instagram
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={instagram}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="instagram"
                                    placeholder="Enter Instagram profile URL"
                                />
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    <i className="fa fa-twitter" style={{ color: "#1da1f2" }}></i> Twitter
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={twitter}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="twitter"
                                    placeholder="Enter Twitter profile URL"
                                />
                            </div>
                        </div>
                        <hr />
                        <h3
                            style={{
                                textAlign: "center",
                                marginBottom: "20px",
                                color: "#333",
                                fontSize: "24px",
                                fontWeight: "bold",
                            }}
                        >
                            <i className="fa fa-info-circle" style={{ color: "#007bff" }}></i> Homepage Sliders Information Update
                        </h3>
                        {/* Slider 1 Title */}
                        <div className="col-lg-6 col-12 mt-4 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Slider 1 Title
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={slider1Title}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="slider1Title"
                                    placeholder="Enter slider 1 title"
                                />
                            </div>
                        </div>

                        {/* Slider 1 Subtitle */}
                        <div className="col-lg-6 col-12 mt-4 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Slider 1 Subtitle
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={slider1SubTitle}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="slider1SubTitle"
                                    placeholder="Enter slider 1 subtitle"
                                />
                            </div>
                        </div>

                        {/* Slider 2 Title */}
                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Slider 2 Title
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={slider2Title}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="slider2Title"
                                    placeholder="Enter slider 2 title"
                                />
                            </div>
                        </div>

                        {/* Slider 2 Subtitle */}
                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Slider 2 Subtitle
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={slider2SubTitle}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="slider2SubTitle"
                                    placeholder="Enter slider 2 subtitle"
                                />
                            </div>
                        </div>

                        {/* Slider 3 Title */}
                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Slider 3 Title
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={slider3Title}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="slider3Title"
                                    placeholder="Enter slider 3 title"
                                />
                            </div>
                        </div>

                        {/* Slider 3 Subtitle */}
                        <div className="col-lg-6 col-12 mb-4">
                            <div className="form-field">
                                <label
                                    className="form-label"
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                        display: "block",
                                        marginBottom: "5px",
                                    }}
                                >
                                    Slider 3 Subtitle
                                </label>
                                <input
                                    style={{
                                        color: "black",
                                        width: "100%",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc",
                                    }}
                                    value={slider3SubTitle}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="slider3SubTitle"
                                    placeholder="Enter slider 3 subtitle"
                                />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="col-lg-12 col-12 text-center">
                            <button
                                type="submit"
                                className="theme-btn"
                                style={{
                                    background: "#007bff",
                                    color: "#fff",
                                    padding: "12px 40px",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    borderRadius: "8px",
                                    border: "none",
                                    cursor: "pointer",
                                    marginTop: "20px",
                                }}
                            >
                                {this.props.id !== "false" ? (
                                    <>
                                        <i className="fa fa-edit"></i> Update Information
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-plus"></i> Add Information
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </>
        );
    }
}
export default InformationForm;